import React from "react";
import styled from "styled-components";
import { tokens } from "../../public/tokens";

const StyledGuestTitle = styled.h4({
    marginTop: tokens.globals["spacing-0"],
    marginBottom: tokens.globals["spacing-0"],
    marginRight: tokens.globals["spacing-1"],
    paddingTop: tokens.globals["spacing-1"],
});

const StyledGuestButton = styled.button(() => {
    return {
        border: `2px solid ${tokens.colors.neutral.white}`,
        color: tokens.colors.neutral.white,
        fontSize: tokens.typography.fontSize["lg-14px"],
        marginLeft: tokens.globals["spacing-2-5"],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "inherit",
        width: "42px",

        "&:hover:enabled": {
            backgroundColor: "#004cfd",
        },

        "& i": {
            margin: "auto",
            fontWeight: tokens.typography.fontWeights.semibold,
        },
    };
});

const JoinAsGuestBox = ({ launchDetail, setLaunchDetail, onCopy, onGuest }) => {
    return (
        <>
            <StyledGuestTitle>
                <i className="fal fa-user-check"></i> Join as Guest&nbsp;
            </StyledGuestTitle>

            <div style={{ display: "flex" }}>
                <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    disabled={launchDetail.launch_show === 0}
                    value={launchDetail.lerner ?? ""}
                    onChange={(e) => setLaunchDetail({...launchDetail, lerner: e.target.value ?? ""})}
                />

                <StyledGuestButton
                    disabled={launchDetail.launch_show === 0}
                    className="btn btn-submit"
                    onClick={onCopy}
                >
                    <i className="fal fa-copy"></i>
                </StyledGuestButton>

                <StyledGuestButton
                    disabled={launchDetail.launch_show === 0}
                    className="btn btn-submit"
                    onClick={onGuest}
                >
                    <i className="fal fa-folder-open"></i>
                </StyledGuestButton>
            </div>
        </>
    );
};

export default JoinAsGuestBox;